
import React, { useEffect, useState } from "react";
import "../css/style.css";

function Boardofdirectors() {
  const [directors, setDirectors] = useState([]);
  const [selectedDirector, setSelectedDirector] = useState(null);

  useEffect(() => {
    const fetchDirectors = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/director/board-of-directors`
        );
        const data = await response.json();
        if (response.ok) {
          setDirectors(data.data); 
        } else {
          console.error("Failed to fetch directors:", data.message);
        }
      } catch (error) {
        console.error("Error fetching directors:", error);
      }
    };

    fetchDirectors();
  }, []);

  // Handle popup open
  const openPopup = (index) => {
    setSelectedDirector(directors[index]);
    document.getElementById("popup-overlay").style.display = "block";
  };

  // Handle popup close
  const closePopup = () => {
    setSelectedDirector(null);
    document.getElementById("popup-overlay").style.display = "none";
  };

  return (
    <>
      <div className="banner-director">
        <div className="banner-text-director">Board of Directors</div>
      </div>

      {/* Content Section */}
      <div className="content-director">
        <h3 className="director-heading">Meet Our Leadership Team</h3>
        <p>
          Discover the leadership driving our vision and mission to deliver
          excellence.
        </p>
      </div>

      {/* Board of Directors Section */}
      <div className="board-of-directors">
        {directors.map((director, index) => (
          <div
            className="director"
            key={director._id}
            onClick={() => openPopup(index)}
          >
            <img
              src={director.image ? director.image : "../img/OIP.jpg"}
              alt={`${director.name}`}
            />
            <br />
            <br />
            <div className="director-name">{director.name}</div>
            <p>{director.designation}</p>
            <div className="plus-sign">+</div>
          </div>
        ))}
      </div>

      {/* Popup for Director Details */}
      <div className="popup-overlay" id="popup-overlay">
        <div className="popup-content">
          <button
            className="close-popup"
            onClick={closePopup}
            aria-label="Close popup"
          >
            ×
          </button>
          {selectedDirector && (
            <>
              <img
                id="popup-img"
                src={selectedDirector.image}
                alt={`${selectedDirector.name}`}
              />
              <div className="popup-description">
                <h2 id="popup-name">{selectedDirector.name}</h2>
                <p id="popup-bio">{selectedDirector.profileSummary}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Boardofdirectors;